/* eslint-disable */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import cx from "classnames";

import { PAGE_LEGAL } from "../../config/pages";

import Footer from "./common/Footer";
import { regexContent } from "../../lib/regexContent";
import { getCmsStatic, companyInfoPropsType } from "../helpers/fetchCmsContent";

const LegalNotice = ({ t, openPage, language, page, claim, companyInfo }) => {
  const legalNoticeClassName = cx("container-legal-notice", {
    open: page === PAGE_LEGAL,
  });

  const [data, setData] = useState("");

  useEffect(() => {
    const fetchContent = async () => {
      const response = await getCmsStatic(page, language);
      setData(response);
    };
    fetchContent();
  }, [language, page]);
  let content;
  if (data) {
    content = regexContent(data, language);
  }

  return (
    <div className={legalNoticeClassName} id={legalNoticeClassName}>
      <div className="layout">
        <div className="page-legal-notice" id="page-legal-notice">
          <div className="section-title" id="section-title-legal-notice">
            <h2 dangerouslySetInnerHTML={{ __html: t("legal.title") }} />
          </div>
          <div className="legal-notice-content" id="legal-notice-content">
            {content && (
              <div className={`${content.key}`}>
                <section className="static-content">
                  <p dangerouslySetInnerHTML={{ __html: content.content }}></p>
                </section>
              </div>
            )}
          </div>
        </div>
      </div>
      <Footer t={t} openPage={openPage} language={language} claim={claim} companyInfo={companyInfo}/>
    </div>
  );
};
LegalNotice.defaultProps = {
  companyInfo: null
};

LegalNotice.propTypes = {
  t: PropTypes.func.isRequired,
  openPage: PropTypes.func.isRequired,
  language: PropTypes.string.isRequired,
  page: PropTypes.string.isRequired,
  claim: PropTypes.string.isRequired,
  companyInfo: companyInfoPropsType
};

export default LegalNotice;



// WEBPACK FOOTER //
// ./src/components/content/LegalNotice.jsx